import { render, staticRenderFns } from "./PlanInfo.vue?vue&type=template&id=1ef4b4f4&scoped=true"
import script from "./PlanInfo.vue?vue&type=script&lang=js"
export * from "./PlanInfo.vue?vue&type=script&lang=js"
import style0 from "./PlanInfo.vue?vue&type=style&index=0&id=1ef4b4f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef4b4f4",
  null
  
)

export default component.exports